import React, { useState } from 'react';

export default function FinanceRejectModal({ invoice, onClose, onReject }) {
    const [reason, setReason] = useState('');

    const handleSubmit = () => {
        if (!reason.trim()) {
            alert("A reason is required for rejection.");
            return;
        }
        onReject(reason);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md">
                <h2 className="text-xl font-bold text-[#213368] mb-4">Reject Invoice</h2>
                <p className="text-sm text-gray-600 mb-1">You are rejecting invoice <span className="font-semibold">{invoice.invoiceNumber}</span>.</p>
                <p className="text-sm text-gray-600 mb-4">Please provide a reason for the rejection.</p>
                <textarea
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    rows="4"
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Rejection comments..."
                ></textarea>
                <div className="flex justify-end space-x-4 mt-6">
                    <button onClick={onClose} className="px-6 py-2 bg-gray-200 text-gray-700 font-medium rounded-lg hover:bg-gray-300">Cancel</button>
                    <button onClick={handleSubmit} className="px-6 py-2 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600">Confirm Rejection</button>
                </div>
            </div>
        </div>
    );
}